import React from 'react';
import {
  Divider,
  Drawer,
  List,
  ListItemButton,
  Typography,
  useTheme,
} from '@mui/material';
import { AIStore } from 'services/store/ai';
import MenuHeader from './MenuHeader';

type PropTypes = {
  open: boolean;
  data: AIStore['infoGuide'];
  children?: React.ReactNode;
  index: number;
  value: number | null;
  handleClick: (value: number) => void;
  handleClose: () => void;
};

function a11yProps(index: number) {
  return {
    id: `list-item-${index}`,
    'aria-controls': `list-item-${index}`,
  };
}

const DRAWER_TRANSITION_DURATION = 500;

const MobileInfoMenu = ({
  open,
  data,
  value,
  handleClick,
  handleClose,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={handleClose}
      transitionDuration={DRAWER_TRANSITION_DURATION}
      sx={{
        zIndex: theme.zIndex.modal + 1,
        '& .MuiDrawer-paper': {
          width: '100%',
          height: '100%',
          boxSizing: 'border-box',
          bgcolor: 'background.paper',
        },
      }}
    >
      <MenuHeader open={open} handleClose={handleClose} />
      <Divider sx={{ borderColor: theme.palette.grey[600] }} />
      <List>
        {data?.map((article, index) => (
          <ListItemButton
            key={article.title}
            selected={index === value}
            {...a11yProps(article.index)}
            onClick={() => handleClick(index)}
            sx={{
              '&.MuiListItemButton-root': {
                borderRadius: 0,
                p: theme.spacing(2, 3),
              },
              '&.MuiListItemButton-root:hover': {
                backgroundColor: theme.palette.grey[800],
                color: theme.palette.grey[50],
              },
            }}
          >
            <Typography variant="body2">{article.title}</Typography>
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
};

export default MobileInfoMenu;
